import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const invoicesServicesRoutes: RouteObject[] = [
  {
    path: ROUTES.INVOICES_SERVICES.LIST,
    element: (
      <PrivateRoute>
        <Pages.InvoicesServices />
      </PrivateRoute>
    ),
  },
]

export default invoicesServicesRoutes
